// extracted by mini-css-extract-plugin
export default {"info-box":"InfoBox_info-box__Rhea+","card":"InfoBox_card__S7Ez-"};